export class BlogUtil {

  static getPosts(graphqlResult): GraphqlBlogPost[] {
    return graphqlResult.allMarkdownRemark.edges.map(edge => edge.node) as GraphqlBlogPost[];
  }

  static getAuthors(post: GraphqlBlogPost): GraphqlBlogAuthor[] {
    if (post.frontmatter.authors && post.frontmatter.authors.length > 0) {
      return post.frontmatter.authors;
    }
    if (post.frontmatter.author) {
      return [post.frontmatter.author];
    }
    return [];
  }


}

export interface GraphqlBlogPost {
  fileAbsolutePath: string;
  frontmatter: {
    title: string;
    tags: string[];
    author?: GraphqlBlogAuthor;
    authors: GraphqlBlogAuthor[];
    date: string;
    category
    description: string;
  }
}

export interface GraphqlBlogAuthor {
  id: string;
  bio: string;
  twitter: string;
}
